module.exports = {"libs.constants.noticeMessage.noticeShowContact":"If you keep seeing this error, contact us at https://choosemuse.com/contactsupport","libs.constants.noticeMessage.general":"Sorry, something went wrong. Please try again.","libs.constants.sessionTimeout.notificationMessage":"You were signed out of your session due to inactivity. Please log into your account to continue your session.","libs.constants.auth.notificationMessage":"You must sign in first"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en/libs/constants.json
// module id = 730
// module chunks = 0